export default __webpack_public_path__ + "static/media/faucet.65892091.png";